import React from 'react';
import PropTypes from 'prop-types';

import { Mobile as AskTheExpertMobile } from '../AskTheExpert';

const LessonHeaderAskTheExpert = ({
  hasLessonExpert,
  hasEmail,
  isPreviewing,
  askTheExpertPostUrl,
  sectionId,
  expertIconName,
  expertName,
  lessonTitle,
}) => {
  if (hasLessonExpert && hasEmail && !isPreviewing) {
    return (
      <AskTheExpertMobile
        postUrl={askTheExpertPostUrl}
        sectionId={sectionId}
        expertIconName={expertIconName}
        expert={{
          name: expertName,
        }}
        lesson={{
          title: lessonTitle,
        }}
      />
    );
  }

  return null;
};

LessonHeaderAskTheExpert.propTypes = {
  hasLessonExpert: PropTypes.bool,
  hasEmail: PropTypes.bool,
  isPreviewing: PropTypes.bool,
  askTheExpertPostUrl: PropTypes.string,
  sectionId: PropTypes.number,
  expertIconName: PropTypes.string,
  expertName: PropTypes.string,
  lessonTitle: PropTypes.string,
};

export default LessonHeaderAskTheExpert;
